import { rtkAssetsClient } from '@gm-commercial/rtk-clients';

import type { AppDispatch } from '~/app/store';
import {
  CustomEvents,
  dispatchCustomEvent,
} from '~/common/utils/custom-events';

/**
 * Refreshes dashboard vehicle data on both connectivity paths. The custom event
 * drives the legacy Redux-thunk refetch, and the tag invalidation drives the
 * RTK Query path used when NEW_CONNECTIVITY_STATUS_FLAG is enabled.
 *
 * @param dispatch - Typed store dispatch, needed for the RTK cache invalidation.
 */
export const refreshDashboardVehicleData = (dispatch: AppDispatch): void => {
  dispatchCustomEvent(CustomEvents.AUTO_ONBOARDING_IMPORT_COMPLETED_EVENT);
  dispatch(rtkAssetsClient.util.invalidateTags(['dashboard-view-controller']));
};
